// Prévia "Como o aluno recebe": a conversa no formato exato do bot, em balões de WhatsApp.
import React, { useMemo, useState } from 'react';
import { FiAlertTriangle, FiClock, FiImage } from 'react-icons/fi';
import { montarConversa } from './mensagensBot';
import { configDoCurso, formatarIntervalo, plural } from './util';
import './Previa.css';

const MARCAS = { '*': 'strong', _: 'em', '~': 's' };
const LETRA_OU_NUMERO = /[\p{L}\p{N}]/u;

// Negrito, itálico e tachado do WhatsApp (*x*, _x_, ~x~) viram <strong>/<em>/<s>.
// Como no WhatsApp, o marcador precisa abrir e fechar na mesma linha, colado ao texto,
// e não pode estar no meio de uma palavra.
export function formatarWhatsApp(texto, chave = 'w') {
  const partes = [];
  let inicio = 0;
  let i = 0;
  while (i < texto.length) {
    const marca = texto[i];
    const Tag = MARCAS[marca];
    const antes = i > 0 ? texto[i - 1] : ' ';
    const depois = texto[i + 1];
    if (Tag && !LETRA_OU_NUMERO.test(antes) && depois && !/\s/.test(depois) && depois !== marca) {
      let fim = -1;
      for (let j = i + 2; j < texto.length && texto[j] !== '\n'; j += 1) {
        if (texto[j] === marca && !/\s/.test(texto[j - 1]) && !LETRA_OU_NUMERO.test(texto[j + 1] || ' ')) {
          fim = j;
          break;
        }
      }
      if (fim > 0) {
        if (i > inicio) partes.push(texto.slice(inicio, i));
        partes.push(<Tag key={`${chave}-${i}`}>{formatarWhatsApp(texto.slice(i + 1, fim), `${chave}-${i}`)}</Tag>);
        i = fim + 1;
        inicio = i;
        continue;
      }
    }
    i += 1;
  }
  if (inicio < texto.length) partes.push(texto.slice(inicio));
  return partes;
}

function Imagem({ url }) {
  const [falhou, setFalhou] = useState(false);
  if (falhou) {
    return (
      <span className="mc-wa__imagem-falha">
        <FiImage aria-hidden="true" />
        <span>Imagem<small>{url}</small></span>
      </span>
    );
  }
  return <img className="mc-wa__imagem" src={url} alt="Imagem enviada antes do texto da pílula" loading="lazy" referrerPolicy="no-referrer" onError={() => setFalhou(true)} />;
}

function PreviaCurso({ curso, etapas, alterada }) {
  const [comExemplos, setComExemplos] = useState(true);
  const itens = useMemo(() => montarConversa(etapas, curso, { comExemplos }), [etapas, curso, comExemplos]);
  const { intervalo, lembrete } = configDoCurso(curso);
  const temQuestao = etapas.some((e) => e.tipoConteudo !== 'pilula');

  return (
    <section className="mc-previa" aria-labelledby="mc-previa-titulo">
      <header className="mc-previa__topo">
        <h3 id="mc-previa-titulo" className="mc-subtitulo">Como o aluno recebe</h3>
        <p className="mc-suave">
          {plural(etapas.length, 'etapa', 'etapas')} · a cada {formatarIntervalo(intervalo)}
          {temQuestao && (lembrete ? ` · lembrete após ${plural(lembrete, 'hora', 'horas')} sem resposta` : ' · sem lembrete')}
        </p>
        {alterada && <p className="qz-badge qz-badge--warning mc-previa__rascunho">Mostrando a sequência ainda não salva</p>}
        {temQuestao && (
          <label className="mc-check">
            <input type="checkbox" checked={comExemplos} onChange={(e) => setComExemplos(e.target.checked)} />
            Mostrar respostas de exemplo
          </label>
        )}
      </header>

      <div className="mc-wa" role="group" aria-label="Conversa de exemplo no WhatsApp (somente leitura)">
        {etapas.length === 0 ? (
          <p className="mc-wa__marco">Sem etapas: quem enviar o comando não recebe nada.</p>
        ) : itens.map((item, i) => {
          const chave = `${item.tipo}-${i}`;
          if (item.tipo === 'marco') {
            return (
              <p key={chave} className={`mc-wa__marco${item.espera ? ' mc-wa__marco--espera' : ''}`}>
                {item.espera && <FiClock aria-hidden="true" />} {item.texto}
              </p>
            );
          }
          if (item.tipo === 'alerta') {
            return (
              <p key={chave} className="mc-wa__alerta">
                <FiAlertTriangle aria-hidden="true" />
                <span>{item.rotulo && <strong>{item.rotulo}: </strong>}{item.texto}</span>
              </p>
            );
          }
          const doAluno = item.tipo === 'aluno';
          return (
            <div key={chave} className={`mc-wa__linha${doAluno ? ' mc-wa__linha--aluno' : ''}`}>
              {item.rotulo && <span className="mc-wa__rotulo">{item.rotulo}</span>}
              <div className={`mc-wa__balao${doAluno ? ' mc-wa__balao--aluno' : ''}${item.exemplo ? ' mc-wa__balao--exemplo' : ''}${item.imagem ? ' mc-wa__balao--imagem' : ''}`}>
                {item.exemplo && <span className="mc-oculto">Exemplo: </span>}
                {item.imagem ? <Imagem url={item.imagem} /> : formatarWhatsApp(item.texto)}
              </div>
              {item.exemplo && doAluno && <span className="mc-wa__nota">resposta de exemplo</span>}
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default PreviaCurso;
